import axios from 'axios';

/**
 * Hand a fetched blob to the browser as a file download.
 */
export const saveBlob = (blob: Blob, filename: string) => {
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
};

/**
 * Backend error message from a failed `responseType: 'blob'` request.
 *
 * The response interceptor lifts `data.message` onto the error for normal JSON
 * requests, but a blob request gets the error body as a Blob too, so the
 * envelope has to be read back out here before the message can be translated.
 */
export const readBlobErrorMessage = async (error: unknown): Promise<string | undefined> => {
  if (!axios.isAxiosError(error)) return undefined;

  const body = error.response?.data;
  if (!(body instanceof Blob)) {
    return typeof error.message === 'string' ? error.message : undefined;
  }

  try {
    const parsed = JSON.parse(await body.text());
    return typeof parsed?.message === 'string' ? parsed.message : undefined;
  } catch {
    return undefined;
  }
};
